module.exports=function(scope){ return `<uses-permission android:name="android.permission.CAMERA" />
<uses-permission android:name="android.permission.INTERNET"/>
// The following two permissions are not required when using Production Keys
<uses-permission android:name="android.permission.ACCESS_NETWORK_STATE"/>
<uses-permission android:name="android.permission.ACCESS_WIFI_STATE"/>`};


// WEBPACK FOOTER //
// ./src/resources/code/getting-started/android-permissions.java.tpl